import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c781f72e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=c781f72e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c781f72e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c781f72e')) {
      api.createRecord('c781f72e', component.options)
    } else {
      api.reload('c781f72e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=c781f72e&scoped=true", function () {
      api.rerender('c781f72e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/order_manage/branch_company_performance/form/detail.vue"
export default component.exports